import React from 'react';
import { navigate } from 'gatsby';
import Button from 'components/Core/Button';
import ContentfulToggle from 'components/Contentful/ContentfulToggle';
import HyperLink from 'components/Core/HyperLink';
import WebsiteImage from 'components/WebsiteImage';
import SubscribeForm from 'components/Form/SubscribeForm';
import SimpleMenu from '../SimpleMenu';

import { ResourcesMenuContainer } from './styles';

const ResourcesMenu = ({ cta, dropdownItems, handleFocus, menu }) => {
  const groups = Array.from(new Set(dropdownItems.map((i) => i?.group?.group))).sort();

  const items = groups.map((group) => {
    const groupElements = dropdownItems.filter((x) => x?.group?.group === group);
    return <SimpleMenu dropdownItems={groupElements} />;
  });

  return (
    <ResourcesMenuContainer>
      <div className="resources-menu-cta-col">
        <div className="toolbox-link">
          <HyperLink data-position="Header - Menu Item CTA" href={menu.url}>
            <div className="toolbox-title">
              <WebsiteImage className="toolbox-icon" {...menu.icon} loading="eager" />
              <h5>The Toolbox</h5>
            </div>
          </HyperLink>
          <HyperLink href="/toolbox" className="header-menu-cta view-all-cta">
            View Toolbox
          </HyperLink>
        </div>
        <p className="resource-sub-menu--subscribe-description">
          A place for contractors to access the best content — articles, webinars, podcasts,
          industry-leading voices and expert advice, all in one place!
        </p>
        <SubscribeForm
          buttonType="secondary"
          notificationMessage="Thanks for subscribing!"
          notificationStyles="notification-message text-left"
          notificationSnack={false}
          formType="Email Capture"
          dataPosition="Navigation"
          shadow={false}
          handleFocus={handleFocus}
          revealProps={{
            styles: 'resource-subscribe-form--legal-info',
          }}
        />
      </div>
      {groups?.length > 1 ? (
        <ContentfulToggle
          startingIndex={0}
          items={items}
          titles={groups.map((x) => x.slice(3))}
          handleDataLayer={(ctaText) => {
            dataLayer.push({
              event: 'cta clicked',
              cta_text: ctaText,
              cta_position: 'Header - Resource Toggle',
            });
          }}
        />
      ) : (
        items
      )}
      {cta && (
        <Button data-position="Header - Menu Item CTA" onClick={() => navigate(cta.url)}>
          {cta.label}
        </Button>
      )}
    </ResourcesMenuContainer>
  );
};

export default ResourcesMenu;
